import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Paper,
  CircularProgress,
  Chip,
  Box,
  Avatar
} from '@mui/material';

export const ChapterSelector = ({ open, onClose, onSelect }) => {
  const [chapters, setChapters] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchChapters = async () => {
    try {
      const response = await fetch('/api/chapters', {
        credentials: 'include'
      });
      const data = await response.json();
      setChapters(Array.isArray(data) ? data : []);
    } catch (error) {
      console.error('Error fetching chapters:', error);
      setChapters([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (open) {
      fetchChapters();
    }
  }, [open]);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Select Chapter</DialogTitle>
      <DialogContent sx={{ padding: 1 }}>
        {loading ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', p: 3 }}>
            <CircularProgress />
          </Box>
        ) : (
          <TableContainer component={Paper}>
            <Table>
              <TableBody>
                {chapters.map((chapter) => (
                  <TableRow 
                    key={chapter._id}
                    sx={{ 
                      '&:hover': { bgcolor: 'action.hover' },
                      cursor: 'pointer'
                    }}
                    onClick={() => onSelect({ 
                      id: chapter._id, 
                      name: chapter.name,
                      avatar: chapter.avatar
                    })}
                  >
                    <TableCell sx={{ padding: 1, width: 50 }}>
                      <Avatar src={chapter.avatar} alt={chapter.name} />
                    </TableCell>
                    <TableCell sx={{ padding: 1 }}>
                      <Chip color="primary" label={chapter.name} />
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </DialogContent>
    </Dialog>
  );
}; 